import { useQuery, useReactiveVar } from "@apollo/client";

import { authenticationStateVar } from "@/apollo/auth-state";
import { AdminPageShell } from "@/components/admin-page-shell";
import { FullPageLoading } from "@/components/full-page-loading";
import { PageIntro } from "@/components/page-intro";
import {
  GET_DRAFT_PREVIEW,
  type GetDraftPreviewData,
  type GetDraftPreviewVariables,
} from "@/graphql";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { IntegrateForm } from "@/pages/integrate/integrate-form";

export function IntegratePage() {
  useDocumentTitle("Integrate");
  const { selectedAccount } = useReactiveVar(authenticationStateVar);

  const { data, loading, error } = useQuery<
    GetDraftPreviewData,
    GetDraftPreviewVariables
  >(GET_DRAFT_PREVIEW, {
    variables: { instagramUsername: selectedAccount },
    skip: !selectedAccount,
  });

  if (!selectedAccount) {
    return (
      <div className="mx-auto max-w-2xl px-8 py-16 text-center">
        <p className="font-inter text-sm text-neutral-500">
          Select an Instagram account to manage integrations.
        </p>
      </div>
    );
  }

  if (loading) return <FullPageLoading label="Loading your draft…" />;

  if (error || !data?.draftPreview) {
    return (
      <div className="mx-auto max-w-2xl px-8 py-16 text-center">
        <p className="font-inter text-sm text-red-600">
          Couldn&apos;t load your draft. Please refresh and try again.
        </p>
      </div>
    );
  }

  return (
    <AdminPageShell className="max-w-4xl">
      <div className="space-y-8">
        <PageIntro
          title="Integrate"
          description="Configure analytics and accessibility settings so your Sked Link is easier to measure and easier to use."
        />

        <IntegrateForm
          instagramUsername={selectedAccount}
          draftPreview={data.draftPreview}
        />
      </div>
    </AdminPageShell>
  );
}
